import { useLocation } from "react-router-dom";
import { Form, FormGroup, Input, Label, Table } from "reactstrap";
import React, { useEffect, useState } from "react";

export function Prediction() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const teamName = searchParams.get("Team");
  const ratioSelected = searchParams.get("leagueselected");
  const API_URL = process.env.REACT_APP_DIRECT || "http://192.168.1.103:8081";

  let tablename;
  tablename = ratioSelected.replace("ratio22", "results");
  console.log(tablename);
  {
    /*
    if (ratioSelected === "ratioepl") {
        tablename = "epl_goal_results"
    } 
*/
  }

  const [data, setData] = useState([]);
  useEffect(() => {
    fetch(`${API_URL}/table/${tablename}`)
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((err) => console.log(err));
  }, []);

  const [selectedTeam, setSelectedTeam] = useState("");

  const handleTeamSelect = (event) => {
    setSelectedTeam(event.target.value);
  };

  //total goal of hometeam at home
  const filteredData = data
    .filter((d) => d.home_team === teamName || d.away_team == teamName)
    .slice(0, 5)
    .filter((d) => d.home_team == teamName);
  const totalHomeScore = filteredData.reduce((total, d) => {
    // Convert home_score to a number using parseFloat or parseInt
    const score = parseFloat(d.home_score); // Use parseInt if home_score should be an integer
    if (!isNaN(score)) {
      return total + score;
    } else {
      // Handle invalid home_score values (e.g., skip them or treat them as 0)
      console.error(`Invalid home_score for ${d.home_team}: ${d.home_score}`);
      return total;
    }
  }, 0);
  //console.log(totalHomeScore);

  const homepoints = (totalHomeScore) => {
    //points for games scored at home for hometeam is 1.5 points
    const points = totalHomeScore * 1.5;
    return parseFloat(points.toFixed(2));
  };

  //total goal of hometeam away
  const filteredData1 = data
    .filter((d) => d.home_team === teamName || d.away_team == teamName)
    .slice(0, 5)
    .filter((d) => d.away_team == teamName);
  const totalHomeScoreaway = filteredData1.reduce((total, d) => {
    // Convert home_score to a number using parseFloat or parseInt
    const score = parseFloat(d.away_score); // Use parseInt if home_score should be an integer
    if (!isNaN(score)) {
      return total + score;
    } else {
      // Handle invalid home_score values (e.g., skip them or treat them as 0)
      console.error(`Invalid home_score for ${d.away_team}: ${d.away_score}`);
      return total;
    }
  }, 0);
  // away goals points for home team
  const awaypoints = (totalHomeScoreaway) => {
    const points = totalHomeScoreaway * 2;
    return parseFloat(points.toFixed(2));
  };

  //total home points

  const totalpoints = (homepoints, awaypoints) => {
    const total = homepoints + awaypoints;
    return total;
  };
  //avarege scored points for hometeam

  const averagehomepoints = (totalpoints) => {
    const average = totalpoints / 5;
    return average;
  };

  // Home total number og goals scored:
  const hometotalscored = (totalHomeScore, totalHomeScoreaway) => {
    const total = totalHomeScore + totalHomeScoreaway;
    return parseFloat(total);
  };

  //total goal of hometeam away
  const filteredData3 = data
    .filter((d) => d.home_team === teamName || d.away_team == teamName)
    .slice(0, 5)
    .filter((d) => d.home_team == teamName);
  const totalHomeconcededhome = filteredData3.reduce((total, d) => {
    // Convert home_score to a number using parseFloat or parseInt
    const score = parseFloat(d.away_score); // Use parseInt if home_score should be an integer
    if (!isNaN(score)) {
      return total + score;
    } else {
      // Handle invalid home_score values (e.g., skip them or treat them as 0)
      console.error(`Invalid home_score for ${d.home_team}: ${d.away_score}`);
      return total;
    }
  }, 0);

  //goal conceded at home points
  const concededhomepoints = (totalHomeconcededhome) => {
    const points = totalHomeconcededhome * 1.5;
    return points;
  };

  //total goal of hometeam away
  const filteredData4 = data
    .filter((d) => d.home_team === teamName || d.away_team == teamName)
    .slice(0, 5)
    .filter((d) => d.away_team == teamName);
  const totalHomeconcededaway = filteredData4.reduce((total, d) => {
    // Convert home_score to a number using parseFloat or parseInt
    const score = parseFloat(d.home_score); // Use parseInt if home_score should be an integer
    if (!isNaN(score)) {
      return total + score;
    } else {
      // Handle invalid home_score values (e.g., skip them or treat them as 0)
      console.error(`Invalid home_score for ${d.away_team}: ${d.home_score}`);
      return total;
    }
  }, 0);

  const concededawaypoints = (totalHomeconcededaway) => {
    const points = totalHomeconcededaway * 1;
    return points;
  };

  // total coceded points

  const totalconcededpoints = (concededhomepoints, concededawaypoints) => {
    const total = concededhomepoints + concededawaypoints;
    return total;
  };

  //avaerage of conceded points home
  const averageconcededhome = (totalconcededpoints) => {
    const average = totalconcededpoints / 5;
    return average;
  };

  //total goal of away at home
  const filteredData5 = data
    .filter((d) => d.home_team === selectedTeam || d.away_team == selectedTeam)
    .slice(0, 5)
    .filter((d) => d.home_team == selectedTeam);
  const totalawayHomeScore = filteredData5.reduce((total, d) => {
    // Convert home_score to a number using parseFloat or parseInt
    const score = parseFloat(d.home_score); // Use parseInt if home_score should be an integer
    if (!isNaN(score)) {
      return total + score;
    } else {
      // Handle invalid home_score values (e.g., skip them or treat them as 0)
      console.error(`Invalid home_score for ${d.home_team}: ${d.home_score}`);
      return total;
    }
  }, 0);

  //goal scored at home points away team
  const scoredhomepoints1 = (totalawayHomeScore) => {
    const points = totalawayHomeScore * 1.5;
    return points;
  };

  // average  of goal scored points by awayteam

  //total goal of hometeam away
  const filteredData6 = data
    .filter((d) => d.home_team === selectedTeam || d.away_team == selectedTeam)
    .slice(0, 5)
    .filter((d) => d.away_team == selectedTeam);
  const totalHomeScoreaway1 = filteredData6.reduce((total, d) => {
    // Convert home_score to a number using parseFloat or parseInt
    const score = parseFloat(d.away_score); // Use parseInt if home_score should be an integer
    if (!isNaN(score)) {
      return total + score;
    } else {
      // Handle invalid home_score values (e.g., skip them or treat them as 0)
      console.error(`Invalid home_score for ${d.away_team}: ${d.away_score}`);
      return total;
    }
  }, 0);

  const concededawaypoints1 = (totalHomeScoreaway1) => {
    const points = totalHomeScoreaway1 * 2;
    return points;
  };
  //total points for away team
  const totalawaypoints = (scoredhomepoints1, concededawaypoints1) => {
    const total = scoredhomepoints1 + concededawaypoints1;
    return total;
  };
  //average scored away team
  const averageawaypoints4 = (totalawaypoints) => {
    const average = totalawaypoints / 5;
    return average;
  };

  // Home total number og goals scored:
  const hometotalscored1 = (totalawayHomeScore, totalHomeScoreaway1) => {
    const total = totalawayHomeScore + totalHomeScoreaway1;
    return parseFloat(total);
  };

  //total goal of hometeam coceded at home
  const filteredData7 = data
    .filter((d) => d.home_team === selectedTeam || d.away_team == selectedTeam)
    .slice(0, 5)
    .filter((d) => d.home_team == selectedTeam);
  const totalHomeconcededhome1 = filteredData7.reduce((total, d) => {
    // Convert home_score to a number using parseFloat or parseInt
    const score = parseFloat(d.away_score); // Use parseInt if home_score should be an integer
    if (!isNaN(score)) {
      return total + score;
    } else {
      // Handle invalid home_score values (e.g., skip them or treat them as 0)
      console.error(`Invalid home_score for ${d.home_team}: ${d.away_score}`);
      return total;
    }
  }, 0);

  //concede away team home score

  const concededhome2 = (totalHomeconcededhome1) => {
    const total = totalHomeconcededhome1 * 1.5;
    return total;
  };

  //total goal of hometeam conceded away
  const filteredData8 = data
    .filter((d) => d.home_team === selectedTeam || d.away_team == selectedTeam)
    .slice(0, 5)
    .filter((d) => d.away_team == selectedTeam);
  const totalHomeconcededaway1 = filteredData8.reduce((total, d) => {
    // Convert home_score to a number using parseFloat or parseInt
    const score = parseFloat(d.home_score); // Use parseInt if home_score should be an integer
    if (!isNaN(score)) {
      return total + score;
    } else {
      // Handle invalid home_score values (e.g., skip them or treat them as 0)
      console.error(`Invalid home_score for ${d.away_team}: ${d.home_score}`);
      return total;
    }
  }, 0);
  //concede away team away score

  const concededaway2 = (totalHomeconcededaway1) => {
    const total = totalHomeconcededaway1 * 1;
    return total;
  };

  //total points for away team
  const totalawaypoints2 = (concededhome2, concededaway2) => {
    const total = concededhome2 + concededaway2;
    return total;
  };

  //average conceded away team
  const averageawayconceded = (totalawaypoints2) => {
    const average = totalawaypoints2 / 5;
    return average;
  };

  //all1
  const all1 = (averagehomepoints, averageawayconceded) => {
    const result = parseFloat((averagehomepoints + averageawayconceded) / 2);
    return result;
  };

  //all2
  const all2 = (averageconcededhome, averageawaypoints4) => {
    const result = parseFloat((averageconcededhome + averageawaypoints4) / 2);
    return result;
  };

  //all3

  const all3 = (all1, all2) => {
    const result = (all1 + all2) / 2;
    return result.toFixed(1);
  };

  return (
    <>
      <div className="alg1_card">
        {/* search form for teams */}
        <div className="search_team">
          simo {ratioSelected}
          <Form className="form_element">
            <FormGroup>
              <select
                className="form-select"
                aria-label="Default select example"
                value={selectedTeam}
                onChange={handleTeamSelect}
              >
                <option value="">Choose Away Team</option>
                {[...new Set(data.map((d) => d.home_team))].map((team, i) => (
                  <option key={i} value={team}>
                    {team}
                  </option>
                ))}
              </select>
            </FormGroup>
          </Form>
        </div>

        <h2>Predictions for {teamName} </h2>
        <div className="section">
          {/* left side of the section*/}
          <div className="section_left">
            <h1>Home team</h1>
            <div className="sec_header">
              &nbsp; &nbsp; &nbsp; &nbsp;{teamName} <br />
              <p> &nbsp; &nbsp; &nbsp; &nbsp;Last 5 matches played: </p>
            </div>
            {/* table for home team results*/}

            <Table striped>
              <thead>
                <tr>
                  <th> Team_A</th>
                  <th> Score_A </th>
                  <th>Team_B </th>
                  <th>Score_B</th>
                </tr>
              </thead>

              <tbody>
                {data
                  .filter(
                    (d) => d.home_team === teamName || d.away_team === teamName
                  )
                  .slice(0, 5)
                  .map((d, i) => (
                    <tr key={i}>
                      <th scope="row">{d.home_team}</th>
                      <td>{d.home_score}</td>
                      <td>{d.away_team}</td>
                      <td>{d.away_score}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
          {/* right side of the section */}
          <div className="section_right">
            <h1>Home team</h1>
            <div className="sec_header">
              &nbsp; &nbsp; &nbsp; &nbsp;{selectedTeam} <br />
              <p> &nbsp; &nbsp; &nbsp; &nbsp;Last 5 matches played:</p>
            </div>
            {/* table for home team results*/}
            <Table striped>
              <thead>
                <tr>
                  <th> Team_A</th>
                  <th> Score_A</th>
                  <th>Team_B</th>
                  <th>Score_B</th>
                </tr>
              </thead>

              <tbody>
                {data
                  .filter(
                    (d) =>
                      d.home_team === selectedTeam ||
                      d.away_team === selectedTeam
                  )
                  .slice(0, 5)
                  .map((d, i) => (
                    <tr key={i}>
                      <th scope="row">{d.home_team}</th>
                      <td>{d.home_score}</td>
                      <td>{d.away_team}</td>
                      <td>{d.away_score}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
        {/* algorithim 1 */}
        <div>
          {teamName} total goals scored at home {totalHomeScore}
          <br />
          {teamName} total goals scored Away: {totalHomeScoreaway} <br />
          {teamName} total goals:
          {hometotalscored(totalHomeScore, totalHomeScoreaway)} in the last 5
          matches
          <br />
          goals scored at home points:{homepoints(totalHomeScore)} &nbsp;points
          <br />
          away goals points: {awaypoints(totalHomeScoreaway)}
          <br />
          total goals scored points:&nbsp;{" "}
          {totalpoints(
            homepoints(totalHomeScore),
            awaypoints(totalHomeScoreaway)
          )}{" "}
          points
          <br /> <br />
          <p>number of goals home team has conceded in last 5 matches</p>
          {teamName}goal conceded at home:{totalHomeconcededhome}
          <br />
          {teamName} away goals conceded away:{totalHomeconcededaway}
          <br />
          goal conceded at home points:{" "}
          {concededhomepoints(totalHomeconcededhome)}
          <br />
          goal conceded away points:{concededawaypoints(totalHomeconcededaway)}
          <br />
          total goals conceded points:
          {totalconcededpoints(
            concededhomepoints(totalHomeconcededhome),
            concededawaypoints(totalHomeconcededaway)
          )}{" "}
          <br />
          avarage of goal scored points :
          {averagehomepoints(
            totalpoints(
              homepoints(totalHomeScore),
              awaypoints(totalHomeScoreaway)
            )
          )}{" "}
          <br />
          average of conceded points:
          {averageconcededhome(
            totalconcededpoints(
              concededhomepoints(totalHomeconcededhome),
              concededawaypoints(totalHomeconcededaway)
            )
          )}
          <p>Away team </p>
          {selectedTeam} total home goals: {totalawayHomeScore} <br />
          {selectedTeam} total away goals:{totalHomeScoreaway1}
          <br />
          {selectedTeam} total goals :{" "}
          {hometotalscored1(totalawayHomeScore, totalHomeScoreaway1)} in the
          last 5 matches <br />
          goals scored at home points:{scoredhomepoints1(
            totalawayHomeScore
          )}{" "}
          <br />
          goals scored at away points:{concededawaypoints1(totalHomeScoreaway1)}
          <br />
          total points scored:
          {totalawaypoints(
            scoredhomepoints1(totalawayHomeScore),
            concededawaypoints1(totalHomeScoreaway1)
          )}
          <p>Goals conceded</p>
          {selectedTeam} total goal conceded at home:{totalHomeconcededhome1}
          <br />
          {selectedTeam} total goal conceded away:{totalHomeconcededaway1}
          <br />
          goal conceded at home points:{concededhome2(totalHomeconcededhome1)}
          <br />
          goal conceded away points : {concededaway2(totalHomeconcededaway1)}
          <br />
          total goals conceded points :{" "}
          {totalawaypoints2(
            concededhome2(totalHomeconcededhome1),
            concededaway2(totalHomeconcededaway1)
          )}{" "}
          <br />
          average of goals scired points:
          {averageawaypoints4(
            totalawaypoints(
              scoredhomepoints1(totalawayHomeScore),
              concededawaypoints1(totalHomeScoreaway1)
            )
          )}
          <br />
          average of conceded points:
          {averageawayconceded(
            totalawaypoints2(
              concededhome2(totalHomeconcededhome1),
              concededaway2(totalHomeconcededaway1)
            )
          )}
          <br />
          <br />
          <span className="results">
            {" "}
            {all3(
              all1(
                averagehomepoints(
                  totalpoints(
                    homepoints(totalHomeScore),
                    awaypoints(totalHomeScoreaway)
                  )
                ),
                averageawayconceded(
                  totalawaypoints2(
                    concededhome2(totalHomeconcededhome1),
                    concededaway2(totalHomeconcededaway1)
                  )
                )
              ),
              all2(
                averageconcededhome(
                  totalconcededpoints(
                    concededhomepoints(totalHomeconcededhome),
                    concededawaypoints(totalHomeconcededaway)
                  )
                ),
                averageawaypoints4(
                  totalawaypoints(
                    scoredhomepoints1(totalawayHomeScore),
                    concededawaypoints1(totalHomeScoreaway1)
                  )
                )
              )
            )}{" "}
          </span>
        </div>
      </div>
    </>
  );
}
